import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('dental_benefits_set', '/dental_benefits_sets', 'benefits_set')
const actions = generator.generate()

export default actions
